import { type WorkExperience } from '~/types'
import { AnimatedDisc } from './animated-disc'

const WORK_EXPERIENCES: WorkExperience[] = [
  {
    isCurrent: true,
    isLast: false,
    time: 'Sept. 2022 - Current 🇦🇺',
    role: 'Lead Software Engineer',
    company: 'NAB (National Australia Bank)',
    companyUrl: 'https://www.nab.com.au',
  },
  {
    isCurrent: false,
    isLast: false,
    time: 'Jan. 2021 - Sept. 2022 🇺🇸',
    role: 'Senior Software Engineer',
    company: 'Inspectorio Inc.',
    companyUrl: 'https://inspectorio.com',
  },
  {
    isCurrent: false,
    isLast: false,
    time: 'Sept. 2019 – Jan. 2021 🇦🇺',
    role: 'Senior Software Engineer',
    company: 'CloudWaitress',
    companyUrl: 'https://www.cloudwaitress.com',
  },
  // {
  //   isCurrent: false,
  //   isLast: false,
  //   time: 'Jan. 2019 – Aug. 2019 🇻🇳',
  //   role: 'Senior Software Engineer',
  //   company: 'Be Group JSC',
  //   companyUrl: 'https://www.be.xyz',
  // },
  {
    isCurrent: false,
    isLast: false,
    time: 'Jun. 2017 – Aug. 2019 🇻🇳',
    role: 'Senior Backend Engineer',
    company: 'Luxstay',
    companyUrl: 'https://www.luxstay.com',
  },
  {
    isCurrent: false,
    isLast: true,
    time: 'Sept. 2014 – May. 2017 🇯🇵',
    role: 'Software Developer',
    company: 'Sun* Inc.',
    companyUrl: 'https://sun-asterisk.vn',
  },
]

const Experience = ({ experience }: { experience: WorkExperience }) => {
  return (
    <div className="relative flex items-baseline dark:text-gray-300">
      <AnimatedDisc animated={experience.isCurrent} />
      {experience.isLast ? null : (
        <div className="absolute top-[18px] left-[6px] h-[calc(100%-14px)] border-2 border-gray-700" />
      )}
      <div className="flex-1 font-mono tracking-tight">
        <span className="text-sm text-gray-600">{experience.time}</span>
        <div className="font-bold tracking-wide">{experience.role}</div>
        <a
          href={experience.companyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="
          text-md
          block
          pb-2
          text-gray-700
          transition-colors
          duration-150
          ease-in
          hover:text-teal-500
          dark:text-gray-100
        "
        >
          {experience.company}
        </a>
      </div>
    </div>
  )
}

const Experiences = () => {
  return (
    <div>
      <h1 className="flex items-center text-3xl font-bold leading-relaxed tracking-wide dark:text-gray-100">
        <span className="text-gradient-animated mr-2 font-mono tracking-tight">
          Experience
        </span>
      </h1>

      {WORK_EXPERIENCES.map((experience, index) => (
        <Experience key={index} experience={experience} />
      ))}
    </div>
  )
}

export { Experiences }
